import { render, staticRenderFns } from "./RecurringShipmentFilter.vue?vue&type=template&id=28b0cc87&"
import script from "./RecurringShipmentFilter.vue?vue&type=script&lang=js&"
export * from "./RecurringShipmentFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports